import React, { memo } from 'react';
import { useTranslation } from '../../../contexts/TranslationContext';
import { Stack } from '@mui/material';
import { AccountInfoSettings } from './AccountInfoSettings';
import { PasswordSettings } from './PasswordSettings';
import { SettingsCard } from './SettingsCard';
import { useIsMobile } from '../../../hooks/useIsMobile';
/* eslint-disable no-useless-escape */

export const AccountSettingsComponent = memo(function AccountSettingsComponent(
  _: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <SettingsCard
      id="account"
      title={t('Account Settings')}
      sx={{ overflow: 'unset' }}
    >
      <Stack direction={isMobile ? 'column' : 'row'} gap={2} p={2}>
        <AccountInfoSettings />
        <PasswordSettings />
      </Stack>
    </SettingsCard>
  );
});
